import { render, staticRenderFns } from "./moban.vue?vue&type=template&id=49573573&scoped=true&"
import script from "./moban.vue?vue&type=script&lang=js&"
export * from "./moban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49573573",
  null
  
)

export default component.exports